import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Intercom } from './core/intercom/intercom.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'app';
  subscriptions: Subscription = new Subscription();
  selectedCountry: string;
  isUk = false;
  isTesting: boolean;
  private loading: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private intercom: Intercom
  ) {

    const isTesting = ['localhost', 'dev', 'staging'].some(key => window.location.host.includes(key));
    localStorage.removeItem('selectedCountry');
    localStorage.setItem('selectedCountry',
      isTesting
        ? 'us' :
        window.location.host.includes('co.uk') ? 'uk' : 'us');
    this.selectedCountry = localStorage.getItem('selectedCountry');
    this.isUk = localStorage.getItem('selectedCountry') === 'uk';

  }

  ngOnInit(): void {
    this.intercom.boot({
      app_id: environment.intercom.appId,
      widget: {
        activator: '#intercom',
      },
    });

    this.subscriptions.add(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          gtag('config', environment.googleAnalytics.trackingId, {
            page_path: (event as NavigationEnd).urlAfterRedirects,
          });
        })
    );
  }

  parseQueryString(queryString) {
    const params = {};
    const queries = queryString.substring(1).split('&');

    for (const query of queries) {
      const pair = query.split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1] || '');

      if (!params[key]) {
        params[key] = value;
      } else if (Array.isArray(params[key])) {
        params[key].push(value);
      } else {
        params[key] = [params[key], value];
      }
    }

    return params;
  }

  ngOnDestroy(): void {
    this.intercom.shutdown();
    this.subscriptions.unsubscribe();
  }
}
